// O estado inicial da aplicação, esse é o state global e deve ser imutável
export const layoutInitial = {
    header: 'Header',
    footer: 'Footer',
    uri: '',
    slug: '',
    type: '',
    id: null,
}
